import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ManagementFormLayout } from 'components/ManagementFormLayout'
import { routes } from 'constants/routes'
import { adCodeStrings } from 'constants/strings'
import { useAdCodeMutations } from 'hooks'
import { useOrgPath } from 'hooks/useOrgPath'
import { toErrorMessage } from 'hooks/utils'
import type { TUpsertAdCodeRequest } from 'types'
import { AdCodeForm } from '../Form/AdCodeForm'
import { NoActiveChannelAlert } from '../NoActiveChannelAlert'

export default function AdCodeCreate() {
  const navigate = useNavigate()
  const orgPathFor = useOrgPath()
  const { create, saving } = useAdCodeMutations()
  const [error, setError] = useState<string | undefined>()
  const submitting = useRef(false)

  const handleSubmit = (request: TUpsertAdCodeRequest) => {
    // isPending が画面に反映される前の連続submitも同期的に止める。
    if (submitting.current) return
    submitting.current = true
    setError(undefined)
    create.mutate(request, {
      // 発行されたURLは詳細画面で初めて見せる
      onSuccess: (adCode) =>
        navigate(
          orgPathFor(routes.AD_CODES_DETAIL.replace(':adCodeId', String(adCode.id))),
          {
            replace: true,
            state: { snackbarMessage: adCodeStrings.messages.created },
          },
        ),
      onError: (mutationError) =>
        setError(
          toErrorMessage(mutationError, adCodeStrings.errors.saveFailed),
        ),
      onSettled: () => {
        submitting.current = false
      },
    })
  }

  return (
    <ManagementFormLayout
      kicker={adCodeStrings.breadcrumb}
      title={adCodeStrings.createTitle}
      description={adCodeStrings.description}
      backTo={orgPathFor(routes.AD_CODES)}
    >
      <p className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
        {adCodeStrings.greetingMeasurementRequirement}
      </p>
      <NoActiveChannelAlert />
      <AdCodeForm
        saving={saving}
        error={error}
        submitLabel={adCodeStrings.form.submitCreate}
        onSubmit={handleSubmit}
        onCancel={() => navigate(orgPathFor(routes.AD_CODES))}
      />
    </ManagementFormLayout>
  )
}
